import { useSearchParams } from "react-router-dom";
import { SEARCH_PARAM_CODE, SEARCH_PARAM_INDEX } from "../../../src/shared";

export const useVerificationCode = () => {
    const [params,] = useSearchParams();
    const index = params.get(SEARCH_PARAM_INDEX);
    const code = params.get(SEARCH_PARAM_CODE);
    if(!index || !code) {
        throw new Error("Invalid verification code");
    }
    return {
        index,
        code
    };
};